import { Link, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import BrandMark from "@/components/BrandMark";

export default function Navbar({ variant = "light" }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-bone/80 border-b border-[#E2DFD8]"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center group" data-testid="nav-logo">
          <BrandMark variant="light" size="sm" />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a href="/#features" className="text-ink/70 hover:text-forest transition-colors" data-testid="nav-features">Features</a>
          <a href="/#how" className="text-ink/70 hover:text-forest transition-colors" data-testid="nav-how">How it works</a>
          <Link to="/store" className="text-ink/70 hover:text-forest transition-colors" data-testid="nav-store">Store</Link>
          <Link to="/pricing" className="text-ink/70 hover:text-forest transition-colors" data-testid="nav-pricing">Pricing</Link>
          <a href="/#waitlist" className="text-ink/70 hover:text-forest transition-colors" data-testid="nav-waitlist">Waitlist</a>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Button variant="ghost" onClick={() => nav("/dashboard")} data-testid="nav-dashboard-btn" className="rounded-full">
                Dashboard
              </Button>
              <Button onClick={handleLogout} data-testid="nav-logout-btn" className="rounded-full bg-forest hover:bg-forest-hover text-bone">
                Sign out
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-link" className="text-sm text-forest hover:text-forest-hover">
                Sign in
              </Link>
              <Link to="/register" data-testid="nav-register-link">
                <Button className="rounded-full bg-forest hover:bg-forest-hover text-bone px-6">Get started</Button>
              </Link>
            </>
          )}
        </div>

        <button
          className="md:hidden text-forest"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Open menu"
        >
          <Menu size={22} />
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-bone border-t border-[#E2DFD8] px-6 py-4 flex flex-col gap-4 text-sm">
          <a href="/#features" onClick={() => setOpen(false)}>Features</a>
          <a href="/#how" onClick={() => setOpen(false)}>How it works</a>
          <Link to="/store" onClick={() => setOpen(false)}>Store</Link>
          <Link to="/pricing" onClick={() => setOpen(false)}>Pricing</Link>
          {user ? (
            <>
              <Link to="/dashboard" onClick={() => setOpen(false)}>Dashboard</Link>
              <button onClick={handleLogout} className="text-left">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)}>Sign in</Link>
              <Link to="/register" onClick={() => setOpen(false)}>Get started</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
